import { render } from "./Privacy.vue?vue&type=template&id=3c80299e"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"
script.render = render

export default script